/** Wi-Fi names of RX/TX keys: `*` followed by 4–6 digits. Mirrors CmdkKeysByWifiController. */
const WIFI_NAME_PATTERN = /^\*\d{4,6}$/;

export function normalizeWifiName(raw: string): string {
    const trimmed = raw.trim();
    if (trimmed === '' || trimmed.startsWith('*')) return trimmed;
    return `*${trimmed}`;
}

export function isValidWifiName(value: string): boolean {
    return WIFI_NAME_PATTERN.test(value);
}

/** Whether a raw palette query is a pasted Wi-Fi name; the `*` is required so bare digits stay a user search. */
export function looksLikeWifiQuery(raw: string): boolean {
    return isValidWifiName(raw.trim());
}
